import React, { useRef, useState } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { useParams } from 'react-router-dom';
import useWidthToElement from '../../../../common/hooks/useWidthToElement';

import { IInvestorDropdownFilter } from '../../types/IInvestorDropdownFilter';

import '../../dropdown/dropdown.scss';
import '../filters.scss';
import './investorDropdownFilter.scss';

const InvestorDropdownFilter: React.FC<IInvestorDropdownFilter> = ({ onChangeCallback, investors }) => {
  const { investorId } = useParams();
  const [width, setWidth] = useState(0);
  const wrapperRef = useRef<any>();

  useWidthToElement(wrapperRef, setWidth);

  const returnDefaultInvestor = () => {
    if (investorId) {
      let defaultInvestor = investors.find((investor) => investor.id === parseInt(investorId));
      return defaultInvestor ? defaultInvestor : investors[0]
    }
    else {
      return investors[0];
    }
  };

  return (
    <div className="investor-dropdown-wrapper" ref={wrapperRef}>
      {investors &&
        <DropDownList
          style={{maxWidth: width}}
          data={investors}
          defaultValue={returnDefaultInvestor()}
          textField="name"
          dataItemKey="id"
          onChange={onChangeCallback} />}
    </div>
  );
};

export default InvestorDropdownFilter;
